import { useMemo } from 'react';

import * as S from './badge.style';
import { BadgeColour, BadgeProps, BadgeSize, BadgeType } from './badge.types';

export const BadgeTestIds = {
  badge: (value: string) => `badge-${value}`,
};

export function Badge(props: Readonly<BadgeProps>) {
  const { value, color, type, size, onClick, leadingIcon, trailingIcon, ...rest } = props;

  const hasPip = useMemo(
    () => type && [BadgeType.DefaultPip, BadgeType.PillPip].includes(type),
    [type]
  );

  const styleColor = useMemo(() => {
    if (hasPip) return BadgeColour.LightWhite;
    return color ?? BadgeColour.LightGray;
  }, [hasPip, color]);

  return (
    <S.Wrapper
      data-testid={BadgeTestIds.badge(value)}
      data-clickable={!!onClick}
      aria-label={value}
      $color={styleColor}
      $type={type ?? BadgeType.Default}
      $size={size ?? BadgeSize.Medium}
      onClick={onClick}
      {...rest}
    >
      {leadingIcon}
      {hasPip && (
        <S.Pip $color={color ?? BadgeColour.Blue} $size={size ?? BadgeSize.Medium} />
      )}
      <S.Value>{value}</S.Value>
      {trailingIcon}
    </S.Wrapper>
  );
}

export default Badge;
